export const blockIconsCommonactionsCategoryNew = (
	<span className='material-symbols-outlined'>category</span>
);
